import React from 'react'

const ReglasChecklist = ({ reglas = [] }) => (
  <div className="flex flex-wrap gap-1">
    {reglas.filter((r) => r.aplica).map((r) => (
      <span
        key={r.key}
        title={r.label}
        className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] leading-none ${
          r.cumple ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
        }`}
      >
        <span>{r.cumple ? '✓' : '✗'}</span>
        <div>{r.label}</div>
      </span>
    ))}
  </div>
)

export default ReglasChecklist
